<script lang="ts" setup>
import { openUserProfile } from '@/components/helper'
import { app } from '@/composition/app'
import { replaceBucketUrlWithCdnUrl } from '@/helper/ImageUpload.helper'
import { GroupMemberRole } from '@/models/GroupMember'
import { IUser } from '@/models/Users'
import { UIPopover } from '@gohighlevel/ghl-ui'
import { PropType } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import UserProfilePopover from '../popover/UserProfilePopover.vue'
import BadgedAvatar from './BadgedAvatar.vue'

defineProps({
  user: {
    type: Object as PropType<any>,
  },
  userRole: {
    type: String as PropType<GroupMemberRole>,
    default: undefined,
  },
  showBadge: {
    type: Boolean,
    default: true,
  },
  showPopover: {
    type: Boolean,
    default: undefined,
  },
  avatarSize: {
    type: Number,
  },
})

const route = useRoute()
const router = useRouter()
</script>
<template>
  <UIPopover
    placement="bottom-start"
    :show-arrow="false"
    raw
    :show="app.state.isMobile ? false : showPopover"
  >
    <template #trigger>
      <div
        tabindex="0"
        role="button"
        aria-label="User Avatar"
        @click.stop.prevent="openUserProfile(user?.slug!, route, router)"
        @keyup.enter="openUserProfile(user?.slug!, route, router)"
      >
        <BadgedAvatar
          :avatar-url="replaceBucketUrlWithCdnUrl(user?.avatar)"
          :full-name="user?.fullName"
          :show-badge="showBadge"
          :role="userRole"
          :size="avatarSize"
          :level="user?.gamificationMeta?.level?.toString()"
        />
      </div>
    </template>
    <UserProfilePopover
      id="user_profile_tooltip"
      class="w-[460px]"
      :user="(user as IUser)"
      :user-role="userRole"
    />
  </UIPopover>
</template>
<style scoped></style>
